<template>
  <focus-lock>
    <el-dialog
      ref="deletedOrganisationDialog"
      v-loading.fullscreen.lock="mainLoader"
      :show-close="false"
      :visible.sync="dialogVisible"
      custom-class="closed-account-dialog"
      element-loading-background="rgba(255, 255, 255, 0.8)"
      @opened="dialogOpen('deletedOrganisationDialog')"
      @close="onClose($event)"
    >
      <div class="body">
        <svg-danger-exclamation />
        <h1>Delete organisation</h1>
        <p>To have your organisation removed from the network please contact the Community Wealth Builder team.</p>
        
        <div class="button-wrap d-flex">
          <el-button
            @click="onClose($event)"
          >
            Go, back
          </el-button>
          <el-button
            type="primary"
            :loading="mainLoader"
          >
            <a href="mailto:Community.WealthBuilder@doncaster.gov.uk" >Email the team</a>
          </el-button>
        </div>
      </div>
    </el-dialog>
  </focus-lock>
</template>
  
<script>
import svgDangerExclamation from '@/components/assets/svg-danger-exclamation'
  
export default {
  
  components: {
    svgDangerExclamation,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    organisation:{
      type: Object,
      default: null
    },
    user : {
      type: Object,
      default: () => {}
    }
  }, 
  data() {
    return {
      mainLoader: false,
      dialogVisible: false,
    }
  },
  
  watch: {
    visible() {
      this.dialogVisible = this.visible
    }
  },
  
  created() {
    this.dialogVisible = this.visible
  },
  
  methods : {
    onClose() {
      this.dialogVisible = false
      this.$emit('closed')
    },
  }
}
</script>
  